import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton/index.jsx";
import LdsImage from "../../components/LdsImage/index.jsx";
import reportTemplateTechnique from "../../assets/module-5/report-template-technique.png";
import LdsBlockList from "../../components/LdsBlockList/LdsBlockList.jsx";
import { FigureCaption } from "react-bootstrap";
import exampleReport from "../../assets/module-5/example-report.png";
import References from "../../components/References/index.jsx";

import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_5_0_2 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}

      <div className="col-sm-8 module-content">
        <main className="module-content">
          <section className="mb-5 learning-heading">
            <h1 className="blue text-uppercase b mt-5">5.0.2 Technique</h1>
            <p className="mt-3 mb-0">Estimated time to complete: 1 minute</p>
          </section>
          <section>
            <LdsBlockList
              items={[
                {
                  title: "Indications for Ordering",
                  bookmarked: false,
                  iconSlug: "pin",
                  active: false,
                },
                {
                  title: "Technique",
                  bookmarked: false,
                  iconSlug: "wrench",
                },
                {
                  title: "Findings",
                  bookmarked: true,
                  iconSlug: "memo",
                  active: false,
                },
                {
                  title: "Impression",
                  bookmarked: true,
                  iconSlug: "mag",
                  active: false,
                },
              ]}
            />
            <div className="content-block callout mb-5 mt-3">
              <LdsImage
                src={reportTemplateTechnique}
                alt="Example of a scan report: 'TECHNIQUE: 30 to 50 minutes after injection of tracer, noncontrast CT images were obtained for attenuation correction followed by a series of overlapping emission pet images of the brain. images were reconstructed and presented in transverse, coronal, and sagittal planes.'"
              />
              <FigureCaption>Example of a Scan Report</FigureCaption>
              <h2 className="h5 bold">
                2. Technique<sup>1</sup>
              </h2>
              <ul>
                <li>
                  Include the <b>name of the radiotracer</b> used and{" "}
                  <b>dose of radioactivity</b> administered
                </li>
                <li>
                  Document the length of time between injection of radiotracer
                  and scanning
                </li>
                <li>
                  Note if there is difficulty with radiotracer injection
                  (particularly infiltration)
                </li>
                <li>
                  Identify the <b>type of imaging technology</b> (PET or PET/CT
                  or PET/MRI) used
                </li>
                <li>
                  Include the methods used for data acquisition, reconstruction,
                  and attenuation
                </li>
              </ul>
            </div>
          </section>
          <div className="text-center">
            <LdsButton
              classes="orange-button mt-3"
              onClick={() => window.open(exampleReport, "_blank")}
            >
              Download Example Report
            </LdsButton>
          </div>
          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-5/module-5-0-1", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-5/module-5-0-3", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
          <References>
            <ol className="no-indent fz-sm">
              <li>
                Minoshima S, Drzezga AE, Barthel H, et al. SNMMI Procedure
                Standard/EANM Practice Guideline for Amyloid PET Imaging of the
                Brain 1.0. <em>J Nucl Med.</em> 2016;57(8):1316-1322.
              </li>
            </ol>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_5_0_2;
